import styled from "styled-components";
import Image, { ImageType } from "../../Image";

type MessageType = { image: ImageType; text: string; className?: string;};

const StyledMessage = styled.div`
  text-align: center;
  font-size: 0.7em;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1em;

  .message > .image {
    padding: 0 1em;
  }

  ${(props: any) => props.customStyle || ""}
` as any;

const Message: React.FC<MessageType> = ({ image, text, className }) => {
  if (!text) return null;

  return (
    <StyledMessage className={className}>
      <div className="image">
        <Image {...image} />
      </div>
      <div className="text">{text}</div>
    </StyledMessage>
  );
};

export default Message;
